// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Wb-z","itemsContainer":"Xb-z"};